import { render, staticRenderFns } from "./tender-details.vue?vue&type=template&id=62b3afa4&scoped=true&"
import script from "./tender-details.vue?vue&type=script&lang=js&"
export * from "./tender-details.vue?vue&type=script&lang=js&"
import style0 from "./tender-details.vue?vue&type=style&index=0&id=62b3afa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3afa4",
  null
  
)

export default component.exports